import { styled, Box, Card, Badge, Button, BoxProps, CardProps, BadgeProps, ButtonProps, Typography, TypographyProps } from '@mui/material'
import { ComponentType } from 'react'

export const StyledCard: ComponentType<CardProps> = styled( Card )( ( { theme } ) => ( {
	padding: theme.spacing( 2 ),
	marginBottom: theme.spacing( 2 ),
	border: `2px solid ${theme.palette.grey[ 400 ]}`,
	boxShadow: 'none',
	borderRadius: '10px',
	maxWidth: '600px',
} ) )

export const StyledBadge: ComponentType<BadgeProps> = styled( Badge )( ( { theme, color } ) => ( {
	'& .MuiBadge-badge': {
		backgroundColor: color === 'default' ? theme.palette.grey[ 400 ] : theme.palette.primary.main, //if we have other colors, we need to account for them
		color: theme.palette.common.white,
		height: '24px',
		borderRadius: '12px',
		width: '24px',
	},
} ) )

export const ContentBox: ComponentType<BoxProps> = styled( Box )( {
	flex: 1,
} )

export const StyledContentTypography: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	marginBottom: theme.spacing( 2 ),
} ) )

export const StyledButton: ComponentType<ButtonProps> = styled( Button )( ( { theme } ) => ( {
	marginBottom: theme.spacing( 1 ),
	padding: theme.spacing( 1, 3 ),
} ) )
